// Unpublished Work © 2021-2022 Deere & Company

import t from 'tcomb';
import {GovernmentTaxId} from '../customer/government-tax-id';

export const OriginalCustomerValues = t.struct({
    businessName1: t.maybe(t.String),
    businessName2: t.maybe(t.String),
    doingBusinessAs: t.maybe(t.String),
    familiarName: t.maybe(t.String),
    firstName: t.maybe(t.String),
    generation: t.maybe(t.String),
    lastName: t.maybe(t.String),
    middleName: t.maybe(t.String),
    prefix: t.maybe(t.String),
    suffix: t.maybe(t.String),
    governmentTaxIds: t.list(GovernmentTaxId)
}, {
    defaultProps: {
        businessName1: '',
        businessName2: '',
        doingBusinessAs: '',
        familiarName: '',
        firstName: '',
        generation: '',
        lastName: '',
        middleName: '',
        prefix: '',
        suffix: '',
        governmentTaxIds: []
    },
    name: 'OriginalCustomerValues'
});
